import { render, staticRenderFns } from "./pending-user-card.vue?vue&type=template&id=8776ee7c"
import script from "./pending-user-card.vue?vue&type=script&lang=js"
export * from "./pending-user-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports